import { HelpIcon, Tooltip, LoadingIndicator } from '@thermon-platforms/thermon-ui-core';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';


function ConfigControl({value, item, error, onChange=() => {}}) {
  const currentValue = value?.requestedValue || value?.value || item.default;
  const requestedTooltipText = t`
    This value has been requested. <br />
    The current value is <strong>${value?.value}</strong> set on:
    ${new Date(value?.lastUpdatedDate).toLocaleString()}.
  `;

  function handleChange(event) {
    onChange(event.target.value);
  }

  return (<>
    <label htmlFor={item.key} className={item.isRemoteSetting ? 'remote-control' : ''}>
      {item.displayName}
    </label>
    {item.options?.length ?
      // Show a select if there are options
      <select
        className={error ? 'error' : ''}
        id={item.key}
        name={item.key}
        onChange={handleChange}
        defaultValue={currentValue}
        data-tooltip-html={value?.requestedValue && value?.requestedValue != value?.value ?
          requestedTooltipText : ''
        }
        data-tooltip-id={`control-tooltip-${item.key}`}
        data-tooltip-offset={24}
        disabled={item.readOnly}
      >
        {/* If there isn't a default value, show a placeholder option */}
        {!item.default ? <option value="">- <Trans>Select</Trans> -</option> : null}
        {item.options.map(option =>
          <option value={option.value || option} key={`option-${option.value || option}`}>
            {option.displayName || option.value || option}
          </option>
        )}
      </select>
    : <>
      {item.unit ?
        // Add unit styling
        <div className="unit-input">
          <input
            className={error ? 'error' : ''}
            id={item.key}
            name={item.key}
            type="text"
            onChange={handleChange}
            defaultValue={currentValue}
            data-tooltip-html={value?.requestedValue && value?.requestedValue != value?.value ?
              requestedTooltipText : ''
            }
            data-tooltip-id={`control-tooltip-${item.key}`}
            data-tooltip-offset={24}
            disabled={item.readOnly}
          />
          <span className="unit">{item.unit}</span>
        </div>
        :
        // Default input fallthrough
        <input
          className={error ? 'error' : ''}
          id={item.key}
          name={item.key}
          type="text"
          onChange={handleChange}
          defaultValue={currentValue}
          data-tooltip-html={value?.requestedValue && value?.requestedValue != value?.value ?
            requestedTooltipText : ''
          }
          data-tooltip-id={`control-tooltip-${item.key}`}
          data-tooltip-offset={24}
          disabled={item.readOnly}
        />
      }
    </>}
    { item.description ? <HelpIcon text={item.description} /> : <></> }
    {(!error && value?.requestedValue && (value?.requestedValue != value?.value)) ?
      <LoadingIndicator show={true} />
    : <></>}
    {error ?
      <p className="error-text">{error}</p>
    : null}

    <Tooltip id={`control-tooltip-${item.key}`} place="right" />
  </>);
}

export default ConfigControl;
